import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3811917a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-page main-content-wrapper col-12" }

import { onBeforeMount, ref, inject } from "vue";
import { useStore } from "vuex";
import ContactFormComponent from "./components/form.vue";
import ContactConfirmComponent from "./components/confirm.vue";
import SuccessComponent from "./components/success.vue";
import { ApiContactRequest, ApiContactResponse } from "../../typings";
import { ContactService } from "../../services";
import { AxiosResponse } from "axios";
import { ValidateError } from "async-validator";
import { get, set } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const clinicId = ref(0);
const currentStep = ref("form");
const formContactValid = ref<ApiContactRequest>();
const errors = ref<ValidateError[]>([]);

const onConfirm = async (contactValidated: ApiContactRequest) => {
  set(formContactValid, contactValidated);
  set(currentStep, "confirm");
};

const checkCurrentStep = stepName => {
  return get(currentStep) == stepName;
};

const onBack = async () => {
  set(currentStep, "form");
};

const onSubmited = async (isConfirm: boolean) => {
  if (!isConfirm) {
    return;
  }

  (await ContactService.saveContact(
    get(formContactValid) as unknown as ApiContactRequest,
    get(clinicId).value,
    () => undefined,
    error => {
      errors.value = error;
    }
  )) as unknown as AxiosResponse<ApiContactResponse>;

  set(currentStep, "success");
};

onBeforeMount(async () => {
  set(clinicId, await inject("clinicId"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(ContactFormComponent, { onConfirm: onConfirm }, null, 512), [
      [_vShow, checkCurrentStep('form')]
    ]),
    _withDirectives(_createVNode(ContactConfirmComponent, {
      "form-contact": formContactValid.value,
      onBack: onBack,
      onSubmit: onSubmited
    }, null, 8, ["form-contact"]), [
      [_vShow, checkCurrentStep('confirm')]
    ]),
    _withDirectives(_createVNode(SuccessComponent, null, null, 512), [
      [_vShow, checkCurrentStep('success')]
    ])
  ]))
}
}

})